/***
*
*   APP LAYOUT
*   Main application layout containing the navigation
*   and header (title, secondary nav and signed in user)
*
*   PROPS
*   title: title of the view
*
**********/

import React, { Fragment, useContext, useState } from 'react';
import { AuthContext, AppNav, Header } from 'components/lib';
// import { useHistory } from 'react-router-dom';
import ClassNames from 'classnames';
import Style from './firm.module.scss';
import '../layout.scss'; // globals
import IdleTimeOutHandler from '../idleTImeoutHandler';

export function FirmLayout(props){

  // context & style
  const context = useContext(AuthContext);
  
  // Initialize sticky state from localStorage
  const [isMenuSticky, setIsMenuSticky] = useState(() => {
    try {
      const stored = localStorage.getItem('ledgerview-menu-sticky');
      return stored === 'true';
    } catch (error) {
      return false;
    }
  });
  
  const css = ClassNames(Style.app, 'with-sidebar', { 'sticky-menu': isMenuSticky });

  const handleStickyChange = (sticky) => {
    setIsMenuSticky(sticky);
  };

  // useEffect(() => {
  //   if (!context.user?.is_firm) {
  //     history.push('/dashboard');
  //   }
  // }, [context.user, history]);

  
  const title = props.title === "Clients" ? !context.user?.is_firm ? "Clients" : props.title : props.title;
  const onLogout = () => {
  context.signout();
    //alert('here')
  }
  return (
    <Fragment>
      <IdleTimeOutHandler 
        onActive={()=>{/* Handler for when user becomes active */}} 
        onIdle={()=>{onLogout()}}
        // onLogout={()=>{alert('here')}}
        />
      <AppNav
        type='popup'
        items={[
          { label: 'Home', icon: 'home', link: '/home' },
          { label: 'Connections', icon: 'link-2', link: '/firm/apps' },
        ]}
        onStickyChange={handleStickyChange}
        bottomItems={[
          ...(context.user.permission !== 'user' 
            ? [{ label: 'Account', icon: 'settings', link: '/firm/users' }] 
            : []),
          { label: 'Profile', icon: 'user', link: '/firm/user/profile/index', },
          { label: 'Help', icon: 'help-circle', link: '/help' },
          { label: 'Sign Out', icon: 'log-out', action: context.signout }
        ]}
      />

      <main className={ css }>

        <Header title={ title } layout="firm" />

        { <props.children {...props.data }/> }

      </main>
    </Fragment>
  );
}
